// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.config.productionTip = false
import animated from 'animate.css'
import useSession from './utils/session'
Vue.prototype.$useSession = useSession
import store from "./store";
import './fonts/iconfont'
//提示
import { successplugIin, errorplugIin, warningplugIin, warnnotification } from "@/utils/information";
Vue.prototype.$successplugIin = successplugIin
Vue.prototype.$errorplugIin = errorplugIin
Vue.prototype.$warningplugIin = warningplugIin
Vue.prototype.$warnnotification = warnnotification
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  window.pageYOffset = 0
});
Vue.use(animated)
Vue.use(ElementUI);

import GlobalComponentsPlugin from '@/utils/overallModule.js'
Vue.use(GlobalComponentsPlugin)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js